import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ResetPasswordPage = () => {
  const { t } = useTranslation();

  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const tokenFromUrl = query.get('token');
    if (tokenFromUrl) setToken(tokenFromUrl);
    else setMessage(t('Invalid link'));
  }, [t]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch('https://summerhousagentlive.onrender.com/api/reset-password-by-token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, newPassword })
    });

    const data = await res.json();
    setMessage(t(data.message));
  };

  return (
    <div style={styles.container}>
      <h2>{t('Set New Password')}</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="password"
          placeholder={t('New Password')}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          style={styles.input}
        />
        <button type="submit" style={styles.button}>{t('Reset Password')}</button>
      </form>
      {message && <p style={styles.message}>{message}</p>}
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <Link to="/loginform" style={styles.backLink}>← {t('Back to Login')}</Link>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: '50px auto',
    padding: '20px',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  input: {
    padding: '10px',
    fontSize: '16px',
    borderRadius: '6px',
    border: '1px solid #ccc'
  },
  button: {
    padding: '10px',
    backgroundColor: '#2980B9',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  message: {
    marginTop: '15px',
    textAlign: 'center',
    color: '#e74c3c'
  },
  backLink: {
    color: '#2980B9',
    textDecoration: 'none',
    fontWeight: '500'
  }
};

export default ResetPasswordPage;
